// ** Custom Components
import { createIconComponent } from "./createIconComponent";

// #####################################################

/**
 * User     Friends Icons Component
 */
export const UserFriendsSolidIcon = createIconComponent(
	"user-friends",
	"solid",
);

export const UserFriendsRegularIcon = createIconComponent(
	"user-friends",
	"regular",
);

// #####################################################
